<template>
  <svg class="icon-hamburger-menu" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 12">
    <path class="cls-1" d="M1,0H17a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1H1A1,1,0,0,1,0,1H0A1,1,0,0,1,1,0Z" />
    <path class="cls-1" d="M1,5H17a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1H1A1,1,0,0,1,0,6H0A1,1,0,0,1,1,5Z" />
    <path class="cls-1" d="M1,10H17a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1H0A1,1,0,0,1,1,10Z" />
  </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.icon-hamburger-menu {
  display: block;
  fill: var(--theme-header-icon2-color);
}
</style>
